import { gql } from '@apollo/client';

export const CheckoutPageFragment = gql`
  fragment CheckoutPageFragment on Cart {
    id
    # eslint-disable-next-line @graphql-eslint/require-id-when-available
    items {
      uid
      quantity
      # eslint-disable-next-line @graphql-eslint/require-id-when-available
      prices {
        price {
          currency
          value
        }
      }
      # eslint-disable-next-line @graphql-eslint/require-id-when-available
      product {
        uid
        name
        sku
        stock_status
      }
    }

    shipping_addresses {
      customer_address_id
      street
      selected_shipping_method {
        carrier_code
        method_code
        method_title
      }
      __typename
    }

    # If total quantity is falsy we render empty.
    total_quantity
    available_payment_methods {
      code
    }
    selected_payment_method {
      code
      title
    }
  }
`;
